import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import Auth from '../../components/auth/Auth';
import { api, isConnected } from '../../reducers';
import { connect as connectApi } from '../../misc/connectAfter';

function mapStateToProps(state) {
  return {
    authentication: state.api.authentication,
    responsive: state.responsive,
    isConnected: isConnected(state)
  };
}

function mapDispatchToProps(dispatch) {
  let checkLogin = api.checkLogin;
  let requestLogout = api.requestLogout;
  return bindActionCreators({ checkLogin, requestLogout }, dispatch);
}

const ConnectedAuth = connect(mapStateToProps, mapDispatchToProps)(withRouter(Auth));

const ApiAuth = connectApi(
  api,
  (state, ownProps) => {
    return {
      me: { dataSource: 'me', withMeta: true },
      endpoints: { dataSource: 'security_endpoints', withMeta: true, filter: "read_permitted:true", only: ["endpoint"] }
    };
  }
)(ConnectedAuth);

export default ApiAuth;